import React from "react";
import { Chip } from "@mui/material";

const phaseColors: Record<string, "info" | "warning" | "success" | "default"> = {
  "Phase 1": "info",
  "Phase 2": "warning",
  "Phase 3": "success",
};

export default function PhaseChip({ phase }: { phase: string }) {
  return (
    <Chip
      label={phase}
      color={phaseColors[phase] || "default"}
      size="small"
      sx={{ fontWeight: 600 }}
    />
  );
}
